import { CurrentUserType, UserRole } from '../types/users'

export const isAdmin = (user?: CurrentUserType | null) => {
  return user?.role === UserRole.Admin
}
export const isEmployee = (user?: CurrentUserType | null) => {
  return user?.role === UserRole.Employee
}
